import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import dashboards
import AdminDashboard from './components/AdminDashboard';
import ClientDashboard from './components/ClientDashboardV2';
import SchoorsteenvegerDashboard from './components/SchoorsteenvegerDashboard';
import PerWebsiteDashboard from './components/PerWebsiteDashboard';
import KeywordDashboard from './components/KeywordDashboard';
import LinkCommandCenter from './components/LinkCommandCenter';

import './App.css';

function App() {
  // Detecteer welk dashboard te tonen op basis van het domein
  const isSchoorsteenvegerDomain = window.location.hostname === 'data.mrschoorsteenveger.nl';
  
  // Als het Schoorsteenveger domein is, toon direct het Schoorsteenveger dashboard
  if (isSchoorsteenvegerDomain) {
    return <SchoorsteenvegerDashboard />;
  }

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* ADMIN DASHBOARD */}
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/analytics" element={<AdminDashboard />} />

          {/* PER-WEBSITE OMZET + ROI (admin) */}
          <Route path="/per-website" element={<PerWebsiteDashboard />} />

          {/* KEYWORD-FIRST: money-keywords + ranking + forecast (admin) */}
          <Route path="/keywords" element={<KeywordDashboard />} />

          {/* LINK COMMAND CENTER: linkbuilding + dropcatch overzicht (admin) */}
          <Route path="/links" element={<LinkCommandCenter />} />

          {/* SCHOORSTEENVEGER DASHBOARD */}
          <Route path="/schoorsteenveger" element={<SchoorsteenvegerDashboard />} />

          {/* CLIENT DASHBOARD */}
          <Route path="/:clientCode" element={<ClientDashboard />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;